import * as React from 'react';
import IconTextButton, { IconTextButtonProps } from './IconTextButton';
import {ResponsiveSize} from '../../components/Responsive';
import Dropdown from './Dropdown';
import ResponsiveProps from '../../components/ResponsiveProps';

export interface IconTextButtonGroupProps extends ResponsiveProps<IconTextButtonGroup> {
    screenSize?: ResponsiveSize;
    label?: string;
    Icon?: React.ReactElement<__MaterialUI.SvgIconProps>;
    style?: React.CSSProperties;
    isRadio?: boolean;
    selectedIndex?: number;
    dataTestId?: string;
    onChange?(event: React.SyntheticEvent<{}>, selectedIndex?: number): void;
}

interface IconTextButtonGroupState {
    selectedIndex: number;
}

export default class IconTextButtonGroup extends React.Component<IconTextButtonGroupProps, IconTextButtonGroupState> {
    static defaultProps = {
        collapsible: true
    };
    private index: number;

    constructor(props: IconTextButtonGroupProps) {
        super(props);
        this.state = {
            selectedIndex: this.props.selectedIndex || this.props.selectedIndex === 0 ?
                this.props.selectedIndex :
                -1
        };
    }

    render() {
        this.index = 0;
        if (this.props.screenSize === ResponsiveSize.Small || this.props.collapsed) {
            return this.renderSmallScreen();
        } else {
            return this.renderNormalScreen();
        }
    }

    protected getStyles() {
        return {
            root: {
                display: 'inline-block',
                marginRight: 24
            }
        };
    }

    private renderNormalScreen() {
        return (
            <div style={Object.assign(this.getStyles().root, this.props.style)}>
                {React.Children.map(this.props.children, this.renderChild)}
            </div>
        );
    }

    private renderSmallScreen() {
        const Icon = this.props.Icon;

        if (!Icon) {
            return this.renderNormalScreen();
        }

        return (
            <Dropdown
                Icon={Icon}
                text={this.props.label}
                isSmart={true}
                useAlternativeColors={true}
                isExpanded={this.props.open}
                onOpen={this.props.onOpen}
                onClose={this.props.onClose}
                dataTestId={this.props.dataTestId}
            >
                {React.Children.map(this.props.children, this.renderChild)}
            </Dropdown>
        );
    }

    private renderChild = (child: React.ReactNode): React.ReactNode => {
        if (this.childIsIconTextButton(child)) {

            const overridenProps = {} as IconTextButtonProps;

            overridenProps.key = this.index;
            overridenProps.style = Object.assign({}, this.getChildStyle(), child.props.style);
            if (this.props.isRadio) {
                overridenProps.isPressable = false;
                overridenProps.isPressed = this.index === this.state.selectedIndex;
                overridenProps.onTouchTap = ((index: number) => (event: React.SyntheticEvent<{}>) => {
                    if (this.state.selectedIndex !== index) {
                        const newState = {} as IconTextButtonGroupState;
                        newState.selectedIndex = index;
                        this.setState(newState);
                        if (this.props.onChange) {
                            this.props.onChange(event, index);
                        }
                    }
                })(this.index);
            }
            this.index++;
            return React.cloneElement(child, overridenProps);
        } else {
            return child;
        }
    }

    private childIsIconTextButton(child: React.ReactNode): child is React.ReactElement<IconTextButtonProps> {
        return child && (child as any).type === IconTextButton;
    }

    private getChildStyle() {
        return {
            marginRight: 4
        };
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/custom-components/icon-text-button/IconTextButtonGroup.tsx
 **/